import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const ChevronLeftIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Main Left</title>
    <polygon points="34.99 4 30.99 4 30.99 4 26.99 4 26.99 4 22.99 4 11.44 24 22.99 44 26.99 44 26.99 44 30.99 44 30.99 44 34.99 44 23.44 24 34.99 4"/>
  </IconBase>
);
